export default __webpack_public_path__ + "static/media/job-opportunities-svgrepo-com.4ad3c70e.svg";